import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { FarmController } from 'src/controllers/farm.controller'
import { UpdateFarmDTO } from 'src/dto/farm.dto'
import { toastSyncSuccess } from 'src/utils/syncToast'

const farmController = new FarmController()

export function useUpdateFarm() {
  const { farmConfig, refreshUserData } = useAuth()
  const queryClient = useQueryClient()
  const baseFarmId = farmConfig?.idFazenda!

  return useMutation({
    mutationKey: ['updateFarm'],
    mutationFn: (payload: UpdateFarmDTO) => farmController.updateFarm(baseFarmId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['getFarmList'] })
      void refreshUserData()
      toastSyncSuccess('Propriedade atualizada com sucesso!')
    },
    onError: () => {
      toast.error('Erro ao atualizar propriedade.')
    }
  })
}
